import { Text } from "components/text";
import { DropdownMenuItem } from "components/ui/dropdown-menu";

export interface ExportOptionProps {
  label: string;
  icon?: React.ReactNode;
  badge?: React.ReactNode;
  disabled?: boolean;

  onClick: () => void;
}

export function ExportOption({
  disabled,
  onClick,
  label,
  icon,
  badge,
}: ExportOptionProps) {
  return (
    <DropdownMenuItem
      className="py-2.5 px-3 cursor-pointer"
      disabled={disabled}
      onClick={onClick}
      role="menuitem"
      aria-label={label}
    >
      <Text as="span" variant="body" className="flex items-center">
        {icon}
        {label}
        {badge}
      </Text>
    </DropdownMenuItem>
  );
}
